(() => {
  const pages = document.querySelectorAll('.wt-page[data-page-handle]');

  pages.forEach((page) => {
    if (page.dataset.pageHandle === 'about-us') {
      const sourceTabs = page.querySelector('.rte .wp-gt');
      const replacement = page.querySelector('[data-wt-about-tabs]');
      const sourceSection = sourceTabs ? sourceTabs.closest('section') : null;

      if (sourceSection && replacement) sourceSection.replaceWith(replacement);

      const tabsRoot = page.querySelector('[data-wt-about-tabs]');
      if (!tabsRoot) return;

      const tabs = Array.from(tabsRoot.querySelectorAll('[role="tab"]'));
      const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
      const activate = (index, focusTab) => {
        tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (panels[tabIndex]) panels[tabIndex].hidden = !selected;
        });
        if (focusTab) tabs[index].focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index, false));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(nextIndex, true);
        });
      });
      activate(0, false);
    }

    if (page.dataset.pageHandle === 'faq') {
      const faq = page.querySelector('.rte .wtfq');
      const searchLabel = faq?.querySelector('.wtfq__search');
      const search = faq?.querySelector('[data-wtfq-search]') || (() => {
        if (!searchLabel) return null;

        const input = document.createElement('input');
        input.type = 'search';
        input.placeholder = 'Search the questions';
        input.autocomplete = 'off';
        input.setAttribute('data-wtfq-search', '');
        searchLabel.append(input);
        return input;
      })();
      const groups = Array.from(faq?.querySelectorAll('.wtfq__group') || []);
      const main = faq?.querySelector('.wtfq__main');

      if (faq && search && main && groups.length) {
        let emptyState = faq.querySelector('[data-wtfq-none]');
        if (!emptyState) {
          emptyState = document.createElement('p');
          emptyState.className = 'wtfq__none';
          emptyState.setAttribute('data-wtfq-none', '');
          emptyState.hidden = true;
          emptyState.append(document.createTextNode('No questions match that search. '));

          const contactLink = document.createElement('a');
          contactLink.href = '/pages/contact';
          contactLink.textContent = 'Ask base camp directly';
          emptyState.append(contactLink, document.createTextNode('.'));
          main.append(emptyState);
        }

        search.addEventListener('input', () => {
          const query = search.value.trim().toLowerCase();
          let totalMatches = 0;

          groups.forEach((group) => {
            let groupMatches = 0;
            group.querySelectorAll('details.wtfq__item').forEach((item) => {
              const matches = !query || item.textContent.toLowerCase().includes(query);
              item.hidden = !matches;
              if (query && matches) item.open = true;
              if (matches) groupMatches += 1;
            });
            group.hidden = Boolean(query) && groupMatches === 0;
            totalMatches += groupMatches;
          });

          emptyState.hidden = !query || totalMatches > 0;
        });
      }
    }

    if (page.dataset.pageHandle === 'contact') {
      const staging = page.querySelector('[data-wt-contact-form-source]');
      const form = staging ? staging.querySelector('#WtContact') : null;
      const target = page.querySelector('.rte .wtct__card');
      if (form && target) {
        const orphanSubmitLabel = Array.from(target.children).find((child) =>
          child.localName === 'span' && child.textContent.trim() === 'Send to base camp'
        );
        const orphanSubmitArrow = orphanSubmitLabel?.nextElementSibling;

        if (orphanSubmitLabel && orphanSubmitArrow?.localName === 'svg' && orphanSubmitArrow.getAttribute('viewBox') === '0 0 24 24') {
          orphanSubmitLabel.remove();
          orphanSubmitArrow.remove();
        }

        target.querySelectorAll('.wtct__topics, .wtct__row, .wtct__field, .wtct__send').forEach((field) => field.remove());
        target.append(form);
        staging.remove();
      }
    }
  });
})();
